import { useEffect } from "react";
import { HUBSPOT_PORTAL_ID } from "@/lib/hubspot";

const SCRIPT_ID = "hs-script-loader";

/**
 * Loads the HubSpot tracking script once when a portal ID is configured.
 */
export function HubSpotTracking() {
  useEffect(() => {
    if (!HUBSPOT_PORTAL_ID) return;
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
    document.body.appendChild(script);
  }, []);

  return null;
}
